import React, { useState, useRef } from "react";
import { Edit } from "react-iconly";

const PostProjectImageCard = ({ onImageUpload }) => {
  const [image, setImage] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileSelect = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    handleFile(file);
  };

  const handleFile = (file) => {
    if (!["image/jpeg", "image/png"].includes(file.type)) {
      alert("Only JPEG and PNG files are allowed.");
      return;
    }
    setImage(URL.createObjectURL(file));
    onImageUpload(file);
  };

  const handleRemoveImage = (event) => {
    event.stopPropagation();
    setImage(null);
    onImageUpload(null);
  };

  return (
    <div
      className="relative w-full max-w-[430px] h-[338px] bg-white rounded-3xl shadow-lg overflow-hidden flex justify-center items-center cursor-pointer hover:shadow-xl transition"
      onClick={() => fileInputRef.current.click()}
    >
      {image ? (
        <div className="relative w-full h-full">
          <img src={image} alt="Uploaded" className="w-full h-full object-cover" />

          <button
            onClick={handleRemoveImage}
            className="absolute top-2.5 right-2.5 bg-black/60 text-white text-sm p-1.5 rounded-full hover:bg-black/80 transition"
          >
            ✕
          </button>

          <div className="absolute top-2.5 left-2.5 w-[58px] h-[49px] rounded-2xl bg-white/60 backdrop-blur-md shadow flex items-center justify-center">
            <Edit set="bold" primaryColor="#000000" size="medium" />
          </div>
        </div>
      ) : (
        <div className="text-center px-6 text-gray-700">
          <p className="text-lg font-semibold mb-1">Click to Upload Project Image</p>
          <p className="text-sm text-gray-500">Accepted: JPG or PNG • Max 5MB</p>
        </div>
      )}

      <input
        type="file"
        accept="image/jpeg, image/png"
        ref={fileInputRef}
        className="hidden"
        onChange={handleFileSelect}
      />
    </div>
  );
};

export default PostProjectImageCard;